"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import MenuItemView from '../../../../../../views/MenuItemView.mjs';
import 'react';

const FilterMenuItem = (props) => {
  const { filterValue } = props;
  return /* @__PURE__ */ jsx(
    MenuItemView,
    {
      id: filterValue.id,
      onAction: () => {
        filterValue.toggle();
      },
      children: filterValue.render()
    }
  );
};

export { FilterMenuItem };
//# sourceMappingURL=FilterMenuItem.mjs.map
